import { useContext } from "react";
import {
  Typography,
  Box,
  CircularProgress,
  IconButton,
  Card,
} from "@mui/material";
import { Add as AddIcon, Casino as CasinoIcon } from "@mui/icons-material";
import { ActivitiesContext } from "../../context/activities/ActivitiesContext";
import ActivitiesList from "./ActivitiesList";
import EmptyActivitiesState from "./EmptyActivitiesState";
import ActivityDialog from "./ActivityDialog";
import RandomActivitySelector from "./RandomActivitySelector";
import HelpLink from "../help/HelpLink";

const Activities = () => {
  const { activities, loaded, openCreateDialog, openRandomSelector } =
    useContext(ActivitiesContext);

  return (
    <>
      <Box className="activities-page__header">
        <Typography variant="h1" className="activities-page__title">
          Activities
        </Typography>
        <HelpLink to="/about/features/activities" color="white" size="large" />
      </Box>

      <Box className="activities-page__container">
        {!loaded ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : activities.length === 0 ? (
          <EmptyActivitiesState />
        ) : (
          <Card className="activities-page__card-container">
            <ActivitiesList />
            <Box className="activities-page__footer">
              <IconButton
                className="activities-page__footer-button"
                onClick={openCreateDialog}
                title="Create Activity"
              >
                <AddIcon />
              </IconButton>
              <IconButton
                className="activities-page__footer-button activities-page__footer-button--random"
                onClick={openRandomSelector}
                title="Random Activity"
              >
                <CasinoIcon />
              </IconButton>
            </Box>
          </Card>
        )}
      </Box>

      <ActivityDialog />
      <RandomActivitySelector />
    </>
  );
};

export default Activities;
